import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { StatsProps } from './types.ts';

export const StatsItem = ({ label, value, dataTest }: StatsProps) => (
  <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }} data-test={dataTest}>
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      {label}
    </Typography>

    <Typography variant="body1Bold" data-test="value">
      {value}
    </Typography>
  </Stack>
);
